import { useState } from 'react';
import TitlePage from '@/components/TitlePage';
import EmployeeStatistics from './components/EmployeeStatistics';
import CustomerStatistics from './components/CustomerStatistics';
import OrderStatistics from './components/OrderStatistics';
import CustomerOrderStatistics from './components/CustomerOrderStatistics';
import TotalOrderChart from './components/TotalOrderChart';
import GiftRequestChart from './components/GiftRequestChart';

const Dashboard = () => {
  const [selectedYear, setSelectedYear] = useState<number>(
    new Date().getFullYear()
  );

  const handleYearChange = (year: number) => {
    setSelectedYear(year);
  };

  return (
    <div className="luxury-theme min-h-screen bg-luxury-50 overflow-y-auto">
      <div className="flex items-center justify-between bg-white p-[18px] border-b border-luxury-200 shadow-sm">
        <div className="flex items-center gap-3">
          <div className="text-2xl  text-luxury-900">
            <TitlePage />
          </div>
        </div>
      </div>
      {/* Total Order Chart */}

      {/* Statistics Blocks */}
      <div className="px-4 sm:px-6 py-4 sm:py-6">
        <div className="grid grid-cols-1 xl:grid-cols-2 gap-4 sm:gap-6 mx-auto mb-6">
          <TotalOrderChart
            selectedYear={selectedYear}
            onYearChange={handleYearChange}
          />
          <GiftRequestChart
            selectedYear={selectedYear}
            onYearChange={handleYearChange}
          />
        </div>
        <div className="grid grid-cols-1 xl:grid-cols-2 gap-4 sm:gap-6 mx-auto">
          <EmployeeStatistics
            selectedYear={selectedYear}
            onYearChange={handleYearChange}
          />
          <CustomerStatistics
            selectedYear={selectedYear}
            onYearChange={handleYearChange}
          />
          <OrderStatistics
            selectedYear={selectedYear}
            onYearChange={handleYearChange}
          />
          <CustomerOrderStatistics
            selectedYear={selectedYear}
            onYearChange={handleYearChange}
          />
        </div>
      </div>
    </div>
  );
};

export default Dashboard;
